import { ref } from 'vue'
import { defineStore } from 'pinia'
import { fetchAuthProfile, type AuthProfile } from '@/api/auth'
import { persistUserDisplayInfo } from '@/api/auth-storage'

export const useUserProfileStore = defineStore('userProfile', () => {
  const profile = ref<AuthProfile | null>(null)
  const loading = ref(false)

  async function load() {
    const { useAuthStore } = await import('@/stores/auth')
    const auth = useAuthStore()
    if (!auth.isLoggedIn) {
      profile.value = null
      return
    }
    loading.value = true
    const tokenAtStart = auth.token
    try {
      const next = await fetchAuthProfile()
      if (!auth.isLoggedIn || auth.token !== tokenAtStart) return
      profile.value = next
    } catch {
      if (auth.isLoggedIn && auth.token === tokenAtStart) {
        profile.value = null
      }
    } finally {
      loading.value = false
    }
  }

  /** 与权限 bootstrap 同源一次请求写入资料，避免 Header 再拉同一接口 */
  function setProfile(next: AuthProfile | null) {
    profile.value = next
    if (next) {
      persistUserDisplayInfo({
        realName: next.realName,
        department: next.department,
        role: next.role,
      })
    }
  }

  function clear() {
    profile.value = null
  }

  return { profile, loading, load, setProfile, clear }
})
